var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.response.items)?_c('renderer',{attrs:{"result":_vm.response.items}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }